import { FieldArray, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import * as Yup from 'yup';
import { ErrorMessage } from 'formik';
import { FaCheckCircle, FaEye, FaTrash } from 'react-icons/fa';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../CommonUtils/SweetAlerts';
import { viewImage } from '../CommonUtils/viewImage';
import { ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import Swal from 'sweetalert2';
//priyanka


export default function DefForSecondInsp({ collCode, nocType, previewMode = false, hideSubmit }) {
    const login = sessionStorage.getItem("user_id");
    const statusScreenLogin = login && login.length > 5;
    const [secondPhaseDef, setSecondPhaseDef] = useState([]);
    const [finalStatus, setFinalStatus] = useState(null);
    const [filetered, setFiletered] = useState([]);
    const [deficienciesCount, setDeficienciesCount] = useState(0);
    const [existingFinalData, setExistingFinalData] = useState({ insp_final_status: '', final_remarks: '' });
    const validationSchema = Yup.object({
        deficiencies: Yup.array().of(
            Yup.object({
                remarks: Yup.string()
                    .required('Remarks is required')
                    .min(5, 'Remarks must be at least 5 characters')
                    .max(500, 'Remarks cannot exceed 500 characters'),
                ...(statusScreenLogin && {
                    asPerNorms: Yup.string()
                        .required('Please select Yes or No')
                        .oneOf(['Yes', 'No'], 'Invalid selection'),
                    phase2Remarks: Yup.string()
                        .required('Phase 2 remarks are required')
                        .min(5, 'Phase 2 remarks must be at least 5 characters')
                        .max(500, 'Phase 2 remarks cannot exceed 500 characters'),
                }),
            })
        ),
        ...(statusScreenLogin && {
            finalStatusValue: Yup.string().required('Final Status is required'),
            finalRemarks: Yup.array().when('finalStatusValue', {
                is: (val) => val === 'DeficiencyIdentified',
                then: (schema) => schema
                    .of(Yup.string().required('Remark is required').min(5, 'Minimum 5 characters'))
                    .min(1, 'At least one final remark is required'),
                otherwise: (schema) => schema.nullable()
            }),
        }),
    });

    const formik = useFormik({
        initialValues: {
            deficiencies: [],
            finalStatusValue: '',
            finalRemarks: [],
        },
        validationSchema,
        onSubmit: () => updateDeficiencyDetailsPost(),
    });
    const isFormFrozen = statusScreenLogin &&
        existingFinalData.insp_final_status &&
        existingFinalData.insp_final_status.trim() !== "" &&
        existingFinalData.final_remarks &&
        existingFinalData.final_remarks.trim() !== "";
    function getOverAllData() {
        let url = `${config.url.FAC_URL}getbyNocType?noc_type=${nocType}&collCode=${collCode}`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const deficiencyData = Array.isArray(res.data.data) ? res.data.data : [];
                    const phase2Data = Array.isArray(res.data.phase2DefFound) ? res.data.phase2DefFound : [];
                    const count = res.data?.colldefFound?.[0]?.count || 0;

                    setDeficienciesCount(count);
                    const filteredata = Array.isArray(deficiencyData) ? deficiencyData.filter(
                        (item) => item.cllg_remarks && item.cllg_remarks.trim() !== ""
                    ) : [];
                    setSecondPhaseDef(deficiencyData);
                    setFiletered(filteredata);
                    const status = deficiencyData[0]?.insp_final_status || null;
                    setFinalStatus(status);
                    const finalStatusValue = deficiencyData[0]?.insp_final_status || '';
                    let finalRemarksArray = [''];
                    if (phase2Data && phase2Data.length > 0) {
                        finalRemarksArray = phase2Data?.map(item => item?.final_remarks || '');
                        if (finalRemarksArray?.length === 0 || (finalRemarksArray?.length === 1 && finalRemarksArray[0] === '')) {
                            finalRemarksArray = [''];
                        }
                    } else {
                        const finalRemarksFromApi = deficiencyData[0]?.final_remarks || '';
                        finalRemarksArray = finalRemarksFromApi ? finalRemarksFromApi.split('\n') : [''];
                    }
                    const finalRemarksString = phase2Data?.length > 0
                        ? phase2Data.map(item => item?.final_remarks).join('\n')
                        : (deficiencyData[0]?.final_remarks || '');

                    setExistingFinalData({
                        insp_final_status: finalStatusValue,
                        final_remarks: finalRemarksString
                    });

                    if (deficiencyData?.length > 0) {
                        const mappedDeficiencies = deficiencyData?.map((item) => ({
                            sno: item.sno,
                            remarks: item?.cllg_remarks || "",
                            file: null,
                            asPerNorms: item?.def_remarks || "",
                            phase2Remarks: item?.inspection_def_remarks || "",
                        }));
                        formik.setFieldValue('deficiencies', mappedDeficiencies);
                        formik.setFieldValue('finalStatusValue', finalStatusValue);
                        formik.setFieldValue('finalRemarks', finalRemarksArray);
                    } else {
                        const emptyDef = statusScreenLogin
                            ? [{ remarks: "", file: null, asPerNorms: "", phase2Remarks: "", phase2File: null }]
                            : [{ remarks: "", file: null }];
                        formik.setFieldValue('deficiencies', emptyDef);
                    }
                }
            })
            .catch((error) => console.error("Error fetching deficiencies:", error));
    }
    useEffect(() => {
        getOverAllData();
    }, [nocType]);
    function updateDeficiencyDetailsPost() {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#1d2b3a",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                const deficienciesPayload = formik?.values?.deficiencies.map((def) => ({
                    sno: def.sno,
                    cllgRemarks: def?.remarks,
                    fileUpload: def?.file,
                    nocType: nocType,
                    defRemarks: def?.asPerNorms,
                    inspDefRemarks: def?.phase2Remarks,
                    finalStatus: formik?.values?.finalStatusValue,
                    collCode: collCode,
                }));
                // const inspectionDef = formik?.values?.finalRemarks.map((remark) => ({
                //     finalRemarks: remark,
                //     nocType: nocType,
                //     collCode: collCode,
                // }));
                const inspectionDef = formik?.values?.finalStatusValue === "DeficiencyIdentified"
                    ? formik?.values?.finalRemarks
                        .filter((remark) => remark.trim() !== "")
                        .map((remark) => ({
                            finalRemarks: remark,
                            nocType: nocType,
                            collCode: collCode,
                        }))
                    : [];
                const payload = {
                    nocType: nocType,
                    deficiencies: deficienciesPayload,
                    inspectionDef: inspectionDef
                };
                const url = config.url.FAC_URL + `updatePhase2Deficiencies`;
                console.log("payload", payload)
                CommonAxiosPost(url, payload)
                    .then((res) => {
                        if (res && res?.data?.ResponseCode === "01") {
                            successAlert2(res?.data?.ResponseDesc || "Submitted Successfully");
                            getOverAllData();
                        } else {
                            failureAlert(res?.data?.ResponseDesc || "Submit failed");
                        }
                    })
                    .catch((error) => {
                        console.error("Error updating deficiency details:", error);
                        failureAlert(error?.response?.data?.sdesc || "Something went wrong");
                    });
            }
        });
    }

    console.log("fromik.erros", formik.errors, "isFormFrozen", isFormFrozen, "dddddddd", formik?.values)
    return (
        <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
                {/* {finalStatus === "DeficiencyIdentified" && Array.isArray(secondPhaseDef) && secondPhaseDef.length > 0 ? ( */}
                {Array.isArray(secondPhaseDef) && secondPhaseDef.length > 0 && deficienciesCount > 0 ? (
                    <>
                        <h2 className="text-success text-center mb-3 fw-bold fs-3">Deficiencies Identified
                            ({nocType}) – Second Level Inspection</h2>
                        <Row>
                            <Col>
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "5%" }}>S.No</th>
                                            <th style={{ width: "20%" }}>Particulars(First Inspection Remarks)</th>
                                            <th style={{ width: "20%" }}>Remarks(college)</th>
                                            <th style={{ width: "20%" }}>Supporting Document(college)</th>
                                            {statusScreenLogin && (
                                                <>
                                                    <th style={{ width: "10%" }}>As Per Norms</th>
                                                    <th style={{ width: "30%" }}>Phase2 Remarks</th>
                                                </>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {secondPhaseDef?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.deficiency_description || item?.remarks || item?.deficiency || item?.deficiences || "-"}</td>
                                                <td>{item?.cllg_remarks || item?.remarks || item?.deficiency || item?.deficiences || "-"}</td>


                                                {/* <td>
                                                    <textarea
                                                        name={`deficiencies[${index}].remarks`}
                                                        value={formik.values.deficiencies[index]?.remarks || ""}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        rows="2"
                                                        placeholder="Enter remarks..."
                                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                                        disabled={isFormFrozen || previewMode}
                                                    />
                                                    <ErrorMessage name={`deficiencies[${index}].remarks`} component="div" style={{ color: 'red', fontSize: '12px' }} />
                                                </td> */}
                                                <td className='text-center'>
                                                    {/* <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="application/pdf"
                                                        onChange={(e) => ImagePdfBucket(e, formik, "/Uploads/grievupload/", `deficiencies[${index}].file`, "file", "pdf")}
                                                        onBlur={formik.handleBlur}
                                                        disabled={isFormFrozen || previewMode}
                                                    /> */}
                                                    {item?.file_upload && (
                                                        <Button type="button" className="btn btn-primary ms-2" onClick={() => viewImage(item?.file_upload)}>
                                                            <FaEye size={10} />
                                                        </Button>
                                                    )}
                                                    <ErrorMessage name={`deficiencies[${index}].file`} component="div" style={{ color: 'red', fontSize: '12px' }} />
                                                </td>
                                                {statusScreenLogin && (
                                                    <>
                                                        <td style={{ verticalAlign: 'middle' }}>
                                                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`deficiencies[${index}].asPerNorms`}
                                                                        value="Yes"
                                                                        className="as-per-norms-radio yes-radio me-1"
                                                                        checked={formik.values.deficiencies[index]?.asPerNorms === "Yes"}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        disabled={isFormFrozen || previewMode}
                                                                    />
                                                                    Yes
                                                                </label>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`deficiencies[${index}].asPerNorms`}
                                                                        value="No"
                                                                        className="as-per-norms-radio no-radio me-1"

                                                                        checked={formik.values.deficiencies[index]?.asPerNorms === "No"}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        disabled={isFormFrozen || previewMode}
                                                                    />
                                                                    No
                                                                </label>
                                                            </div>
                                                            <ErrorMessage name={`deficiencies[${index}].asPerNorms`} component="div" style={{ color: 'red', fontSize: '12px', textAlign: 'center' }} />
                                                        </td>
                                                        <td>
                                                            <textarea
                                                                name={`deficiencies[${index}].phase2Remarks`}
                                                                value={formik.values.deficiencies[index]?.phase2Remarks || ""}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                rows="2"
                                                                placeholder="Enter Phase 2 remarks..."
                                                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                                                                disabled={isFormFrozen || previewMode}
                                                            />
                                                            <ErrorMessage name={`deficiencies[${index}].phase2Remarks`} component="div" style={{ color: 'red', fontSize: '12px' }} />
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {statusScreenLogin && (
                                    <>
                                        <Row className="mt-4">
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">Final Status <span className="text-danger">*</span></label>
                                                    <select
                                                        name="finalStatusValue"
                                                        className="form-select"
                                                        value={formik.values.finalStatusValue}
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            // Clear finalRemarks when status changes
                                                            // formik.setFieldValue('finalStatusValue', e.target.value);
                                                            formik.setFieldValue('finalRemarks', ['']);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        disabled={isFormFrozen || previewMode}
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value="DeficiencyIdentified">Deficiencies Identified</option>
                                                        <option value="NoDeficienciesIdentified">No Deficiencies Identified</option>
                                                    </select>
                                                    <ErrorMessage name="finalStatusValue" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {formik?.values?.finalStatusValue === "DeficiencyIdentified" && (
                                                <Col md={12}>
                                                    <label className="form-label fw-bold">Final Remarks <span className="text-danger">*</span></label>
                                                    <FieldArray name="finalRemarks">
                                                        {({ push, remove, form }) => (
                                                            <div>
                                                                <div className="table-responsive">
                                                                    <Table striped bordered hover className="mt-2">
                                                                        <thead className="table-primary">
                                                                            <tr>
                                                                                <th style={{ width: "8%" }} className="text-center">S.No</th>
                                                                                <th style={{ width: "82%" }}>Remarks</th>
                                                                                <th style={{ width: "10%" }} className="text-center">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {form?.values?.finalRemarks?.length === 0 ? (
                                                                                <tr>
                                                                                    <td colSpan="3" className="text-center text-muted">
                                                                                        No remarks added. Click "Add Remark" to continue.
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                form?.values?.finalRemarks?.map((remark, idx) => (
                                                                                    <tr key={idx}>
                                                                                        <td className="text-center align-middle fw-bold">{idx + 1}</td>
                                                                                        <td>
                                                                                            <textarea
                                                                                                name={`finalRemarks.${idx}`}
                                                                                                value={remark}
                                                                                                onChange={form.handleChange}
                                                                                                onBlur={form.handleBlur}
                                                                                                rows="2"
                                                                                                className="form-control"
                                                                                                placeholder={`Enter final remark ${idx + 1}`}
                                                                                                disabled={isFormFrozen || previewMode}
                                                                                                style={{ resize: 'vertical' }}
                                                                                            />
                                                                                            {formik.errors.finalRemarks?.[idx] && formik.touched.finalRemarks?.[idx] && (
                                                                                                <div className="text-danger small mt-1">
                                                                                                    {formik.errors.finalRemarks[idx]}
                                                                                                </div>
                                                                                            )}
                                                                                        </td>
                                                                                        <td className="text-center align-middle">
                                                                                            <Button
                                                                                                type="button"
                                                                                                variant="outline-danger"
                                                                                                size="sm"
                                                                                                onClick={() => remove(idx)}
                                                                                                disabled={isFormFrozen || previewMode}
                                                                                                title="Remove remark"
                                                                                            >
                                                                                                <FaTrash />
                                                                                            </Button>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            )}
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr className="table-secondary">
                                                                                <td colSpan="3" className="text-end">
                                                                                    <Button
                                                                                        type="button"
                                                                                        variant="success"
                                                                                        size="sm"
                                                                                        onClick={() => push('')}
                                                                                        disabled={isFormFrozen || previewMode}
                                                                                    >
                                                                                        + Add New Remark Row
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        </tfoot>
                                                                        {form?.values?.finalRemarks?.length > 0 && (
                                                                            <tfoot>
                                                                                <tr>
                                                                                    <td colSpan="3" className="text-end">
                                                                                        <small className="text-muted">
                                                                                            Total Remarks: {form?.values?.finalRemarks?.length}
                                                                                        </small>
                                                                                    </td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        )}
                                                                    </Table>
                                                                </div>
                                                                {typeof formik.errors.finalRemarks === 'string' && (
                                                                    <div className="text-danger mt-2 small">
                                                                        {formik.errors.finalRemarks}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </Col>
                                            )}
                                        </Row>
                                    </>
                                )}
                                {!hideSubmit ?
                                    <>

                                        <div className="text-end mt-3">
                                            {existingFinalData?.insp_final_status !== null && existingFinalData?.insp_final_status !== undefined && existingFinalData?.insp_final_status !== '' ? (
                                                <div className="alert alert-success d-inline-block">
                                                    <FaCheckCircle className="me-2" />
                                                    <strong>Already Submitted</strong>
                                                </div>
                                            ) : (
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                            )}
                                        </div>
                                    </> : <></>}

                            </Col>
                        </Row>
                    </>
                ) : finalStatus === "NoDeficienciesIdentified" ? (
                    <Card className="text-center shadow-sm m-4">
                        <Card.Body>
                            <FaCheckCircle size={50} className="text-success mb-3" />
                            <Card.Title className="text-success">No Deficiencies Identified</Card.Title>
                            <Card.Text>Your application has no deficiencies.</Card.Text>
                        </Card.Body>
                    </Card>
                ) : (
                    <h5 className="text-danger text-center mb-3">No Data Found</h5>
                )}
            </Form>
        </FormikProvider >
    );
}